// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__2PzHa","inputSearch":"SearchBar_inputSearch__IPAay","searchButton":"SearchBar_searchButton__IK4X7"};